export const tinkBlue = {
  100: '#F3FAFC',
  200: '#E6F5F8',
  300: '#B6E1EC',
  400: '#9FD8E7',
  500: '#86CEE0',
  600: '#6EC5DA',
  700: '#56BBD4',
  800: '#0E9EC2',
  900: '#056C85',
};
